import React, { useEffect, useRef, useState } from 'react';
import classes from './MedioLoginBox.module.scss';
import { Button, Input } from '@medio/ui';
import At from '../../assets/at.svg';
import SynlabIcon from '../../assets/synlab-icon.png';
import { post, startLoading, endLoading, alrt } from '../../lib/legacy';
import LoginTypeSwitcher from '../LoginTypeSwitcher';

export function MedioLoginBox(props: ComponentProps) {
	const [from, setFrom] = useState('');
	const [code, setCode] = useState('');
	const [encodedCredentials, setEncodedCredentials] = useState('');
	const [decodedCredentials, setDecodedCredentials] = useState('');
	const [lng, setLng] = useState('');

	const passwordRef = useRef(null);
	const [isPwVisible, setIsPwVisible] = useState(false);
	const [state, setState] = useState({
		email: '',
		password: '',
	});

	const ALERT_MESSAGES = {
		errorTryAgain: props.translates
			? props.translates.error_try_again
			: 'Valami hiba történt. Kérjük, próbálja meg újból!',
		systemError: props.translates ? props.translates.system_error : 'Rendszerhiba!',
		emailNotFound: props.translates ? props.translates.email_not_found : 'Nem található ilyen email cím!',
		wrongEmailFormat: props.translates ? props.translates.wrong_email : 'Helytelen email formátum!',
		emptyEmail: props.translates ? props.translates.empty_email : 'Nem adott meg email címet!',
		userNotFound: props.translates ? props.translates.user_not_found : 'Nem található felhasználó!',
	};

	useEffect(() => {
		// @ts-ignore
		passwordRef.current && passwordRef.current.focus();
	}, [isPwVisible]);

	useEffect(() => {
		// Az URL lekérdezése
		const url = new URL(window.location.href);
		const fromParam = url.searchParams.get('from') || '';
		const codeParam = url.searchParams.get('code') || '';
		const respParam = url.searchParams.get('resp') || '';
		const lngParam = url.searchParams.get('lng') || '';

		// Csak akkor folytatódjon a kód, ha fromParam értéke "Synlab"
		if (fromParam === 'Synlab') {
			// Állapotok frissítése az URL paraméterekkel
			setFrom(fromParam);
			setCode(codeParam);
			setEncodedCredentials(respParam);
			setLng(lngParam);

			// Ellenőrizni a codeParam értékét
			if (codeParam === 'OK') {
				// Ha codeParam "OK", akkor haladjon tovább
				// Ide írd a továbbhaladáshoz szükséges kódot
			} else if (codeParam === 'SYSTEM_ERROR') {
				// Ha codeParam "SYSTEM_ERROR", akkor jeleníts meg egy hibaüzenetet
				alrt(ALERT_MESSAGES.systemError);
				return;
			} else if (codeParam === 'USER_NOT_FOUND') {
				// Ha codeParam "USER_NOT_FOUND", akkor jeleníts meg egyedi üzenetet
				alrt(ALERT_MESSAGES.userNotFound);
				return;
			}

			// Dekódoljuk az encodedCredentials-et, ha van
			if (respParam) {
				const decodedCredentials = atob(respParam);
				setDecodedCredentials(decodedCredentials);
				/* 				setIsPwVisible(true); */
			}
		}
	}, []);

	useEffect(() => {
		if (decodedCredentials) {
			const [email, password] = decodedCredentials.split(':');
			setIsPwVisible(true);
			startLoading();

			handlePassword({ email: email, password: password });
		}
	}, [decodedCredentials]);

	const handleEmailCheck = () => {
		post('api/v1/auth/amnt-internal-user-login-with-email', { email: state.email })
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						setIsPwVisible(true);
						break;
					case 'EMAIL_NOT_FOUND':
						alrt(ALERT_MESSAGES.emailNotFound);
						break;
					case 'WRONG_EMAIL_FORMAT':
						alrt(ALERT_MESSAGES.wrongEmailFormat);
						break;
					case 'EMPTY_EMAIL':
						alrt(ALERT_MESSAGES.emptyEmail);
						break;
					default:
						alrt(ALERT_MESSAGES.errorTryAgain);
						break;
				}
			})
			.catch((error) => {
				if (error.message === 'INSTITUTION_MODULE_ACCESS_DENIED') {
					endLoading();
					return false;
				}
				alert(ALERT_MESSAGES.errorTryAgain);
				endLoading();
			});
	};

	const handlePassword = (data: any = null) => {
		if (data) {
			if (props.handleMedioLogin) {
				props.handleMedioLogin(data);
			}
		} else {
			if (props.handleMedioLogin) {
				props.handleMedioLogin(state);
			}
		}
	};

	const handleForgotPassword = () => {
		post('api/v1/auth/internal-forgot-password', { email: state.email })
			.then((response) => response.json())
			.then((response) => {
				endLoading();
				switch (response.responseCode) {
					case 'OK':
						alrt(
							props.translates
								? props.translates.password_sent
								: 'Jelszavát elküldtük a megadott email címre!'
						);
						break;
					default:
						alrt(ALERT_MESSAGES.errorTryAgain);
						break;
				}
			})
			.catch((error) => {
				console.error(error);
				endLoading();
				alrt(ALERT_MESSAGES.errorTryAgain);
			});
	};

	const handleSynlabLogin = () => {
		const url = 'https://medicall.cc/api/v1/synlab/auth/admin';
		window.location.href = url;
	};

	useEffect(() => {
		if (lng === 'en-GB') {
			window.localStorage.setItem('i18nextLng', 'en');
		} else if (lng === 'hu-HU') {
			window.localStorage.setItem('i18nextLng', 'hu');
		}
	}, [lng]);

	return (
		<div className={classes.MedioLoginBox}>
			<h3 className={classes.LoginTitle}>{props.loginTitle}</h3>
			<p className={classes.LoginDescription}>
				{props.translates
					? props.translates.login_description
					: 'A bejelentkezéshez kérjük válassza ki a platformot, majd adja meg e-mail címét és jelszavát.'}
			</p>
			<LoginTypeSwitcher loginType={props.loginType} setLoginType={props.setLoginType} />
			<div className={classes.formItem}>
				<span className={classes.formItemTitle}>
					{props.translates ? props.translates.email : 'E-mail cím'}
				</span>
				<div id="emailInput" className={classes.InputWrapper}>
					<Input
						type="email"
						name="email"
						className={classes.CustomInput}
						onChange={(event: { target: { value: any } }) =>
							setState({ ...state, email: event.target.value })
						}
						value={state.email}
						onEnter={() => handleEmailCheck()}
					/>
					<img className={classes.InputIcon} src={At} alt="Email input icon" />
				</div>
			</div>
			{isPwVisible && (
				<div className={classes.formItem}>
					<span className={classes.formItemTitle}>
						{props.translates ? props.translates.password : 'Jelszó'}
					</span>
					<div id="pwInput" className={classes.InputWrapper}>
						<Input
							ref={passwordRef}
							type="password"
							className={classes.CustomInput}
							onChange={(event: { target: { value: any } }) =>
								setState({ ...state, password: event.target.value })
							}
							value={state.password} // Populate the value of the password input field with state.password
							onEnter={() => handlePassword(state)}
						/>
						{/*<img className={classes.InputIcon} src={Key} alt="Password input icon"/>*/}
					</div>
				</div>
			)}
			<div className={classes.actionsContainer}>
				{isPwVisible && (
					<Button
						className={classes.forgotButton}
						text={props.translates ? props.translates.forgot_password : 'Elfelejtette jelszavát?'}
						onClick={handleForgotPassword}
					/>
				)}
				<Button
					className={classes.nextButton}
					text={
						isPwVisible
							? props.translates
								? props.translates.login
								: 'Bejelentkezés'
							: props.translates
							? props.translates.next
							: 'Tovább'
					}
					onClick={isPwVisible ? handlePassword : handleEmailCheck}
				/>
			</div>
			{/* {!isPwVisible && (
				<div className={classes.synlabButton} onClick={handleSynlabLogin}>
					<img className={classes.synlabIcon} src={SynlabIcon} alt="Synlab Icon"/>
					<span
						className={classes.synlabText}>{props.translates ? props.translates.login_with_synlab : 'Bejelentkezés Synlab Access-el'}</span>
				</div>
			)} */}
		</div>
	);
}

interface ComponentProps {
	loginTitle: any;
	loginType: string;
	setLoginType: any;
	handleMedioLogin?: Function;
	translates?: any;
}
